import { render } from "./ClsPage.vue?vue&type=template&id=3e5a2a52&scoped=true"
import script from "./ClsPage.vue?vue&type=script&lang=js"
export * from "./ClsPage.vue?vue&type=script&lang=js"

import "./ClsPage.vue?vue&type=style&index=0&id=3e5a2a52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5a2a52"]])

export default __exports__